(ns common.schema.entities.counterparty-diligence.templates.capman.board-member
  (:require
   [common.schema.entities.counterparty-diligence.templates.questions.board-member :as board-member-q]
   [common.schema.entities.counterparty-diligence.templates.questions.person :as person-q]
   [potpuri.core :as p]))

(def identification-field-kws
  (->> [person-q/type-of-identification-attachment
        person-q/identification-expiration-date
        person-q/passport-photo-page-file
        person-q/id-card-front-file
        person-q/id-card-back-file]
       (mapv :field)))

(def role
  (-> board-member-q/role
      (assoc :linked-fields identification-field-kws)
      (update :options
              conj
              {:key   :vice-chair-of-the-board
               :value :vice-chair-of-the-board
               :label {:en "Vice chair of the board"
                       :fi "Hallituksen varapuheenjohtaja"}})))

(defn chair-of-the-board?
  [{:keys [data]}]
  (-> data
      :board-member/role
      (= :chair-of-the-board)))

(def schema
  {:template/schema
   (merge
    (->> [person-q/first-names-singular-label
          person-q/middle-names
          person-q/last-name
          role
          person-q/date-of-birth
          person-q/nationalities]
         (p/index-by :field))

    {(:field person-q/type-of-identification-attachment)
     (merge
      person-q/type-of-identification-attachment
      {:visibility-fn chair-of-the-board?
       :mandatoriness :mandatory/when-visible})}

    {(:field person-q/identification-expiration-date)
     (merge
      person-q/identification-expiration-date
      {:visibility-fn chair-of-the-board?
       :mandatoriness :mandatory/when-visible})}

    {(:field person-q/passport-photo-page-file)
     (merge
      person-q/passport-photo-page-file
      {:visibility-fn (fn [{:keys [data] :as args}]
                        (and (chair-of-the-board? args)
                             (-> data
                                 :person/type-of-identification-attachment
                                 (= :identification.type/passport))))})}

    {(:field person-q/id-card-front-file)
     (merge
      person-q/id-card-front-file
      {:visibility-fn (fn [{:keys [data] :as args}]
                        (and (chair-of-the-board? args)
                             (-> data
                                 :person/type-of-identification-attachment
                                 (= :identification.type/id-card))))})}

    {(:field person-q/id-card-back-file)
     (merge
      person-q/id-card-back-file
      {:visibility-fn (fn [{:keys [data] :as args}]
                        (and (chair-of-the-board? args)
                             (-> data
                                 :person/type-of-identification-attachment
                                 (= :identification.type/id-card))))})})

   :template/sections
   {:basic-information
    {:ord   0
     :title {:en "Basic information"}
     :fields (->> [person-q/first-names-singular-label
                   person-q/middle-names
                   person-q/last-name
                   role
                   person-q/date-of-birth
                   person-q/nationalities]
                  (mapv :field))}

    :identification
    {:ord 1
     :title {:en "Identification"}
     :visibility-fn chair-of-the-board?
     :fields identification-field-kws}}})
